import ApiClient from './apiClient'
import {
  RequestApplicationFavorite,
  RequestApplicationDetail,
  ResponseApplicationDetail,
  ResponseApplicationList,
  RequestReportDetail,
  ResponseReportWorkStyle,
  ResponseReportPrint,
  ResponseReportApplicationList,
  ResponseReportApplicationMember,
} from '../types/analyze'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getApplicationList = async (params: RequestReportDetail): Promise<any> => ApiClient.get(
  '/api/analysis/company_service/list',
  (result: ResponseApplicationList) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getApplicationDetail = async (params: RequestApplicationDetail): Promise<any> => ApiClient.get(
  '/api/analysis/company_service/detail',
  (result: ResponseApplicationDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getApplicationFrequency = async (params: RequestApplicationDetail): Promise<any> => ApiClient.get(
  '/api/analysis/company_service/frequency',
  (result: ResponseApplicationDetail) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const postApplicationFavorite = async (params: RequestApplicationFavorite): Promise<any> => ApiClient.post(
  '/api/analysis/member_favorite_company_service',
  () => {
    // do nothing
  },
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteApplicationFavorite = async (params: RequestApplicationFavorite): Promise<any> => ApiClient.delete(
  `/api/analysis/member_favorite_company_service?service_name=${params.service_name}`,
  () => {
    // do nothing
  },
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getReportPrint = async (params: RequestReportDetail): Promise<any> => ApiClient.get(
  '/api/analysis/report/print',
  (result: ResponseReportPrint) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getReportWorkStyle = async (params: RequestReportDetail): Promise<any> => ApiClient.get(
  '/api/analysis/report/work_style',
  (result: ResponseReportWorkStyle) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getReportApplicationList = async (params: RequestReportDetail): Promise<any> => ApiClient.get(
  '/api/analysis/report/software_usage/application',
  (result: ResponseReportApplicationList) => result,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getReportApplicationMember = async (params: RequestReportDetail): Promise<any> => ApiClient.get(
  'api/analysis/report/software_usage/member',
  (result: ResponseReportApplicationMember) => result,
  params,
)
